import PropTypes from 'prop-types';
import React from 'react';
import {connectToStores} from 'fluxible-addons-react';
import {Link} from 'react-router';
import {FormattedMessage, intlShape} from 'react-intl';
import CommonMessages from '../../../intl/CommonMessages';
import AccountMessages from '../components/AccountMessages';
import {editAccount, clearMessages, changeSelectedClient} from '../actions/AccountActionCreators';
import Immutable from 'immutable';
import ProtectedComponent from '../../../components/ProtectedComponent';
import Roles from '../../../constants/Roles';

@connectToStores(['ManageAccountStore', 'PortalUserStore'], (context) => {
  const PortalUserStore = context.getStore('PortalUserStore');
  const ManageAccountStore = context.getStore('ManageAccountStore');

  return {
    accountUpdated: ManageAccountStore.saved(),
    passwordResetSent: ManageAccountStore.passwordResetSent(),
    firstName: PortalUserStore.getFirstName(),
    lastName: PortalUserStore.getLastName(),
    emailAddress: PortalUserStore.getEmailAddress(),
    title: PortalUserStore.getTitle(),
    enabledClients: PortalUserStore.getEnabledClients(),
    selectedClient: PortalUserStore.getSelectedClient()
  };
})
class ViewAccount extends React.Component {

  static propTypes = {
    accountUpdated: PropTypes.bool.isRequired,
    passwordResetSent: PropTypes.bool.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    emailAddress: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    enabledClients: PropTypes.array.isRequired,
    selectedClient: PropTypes.object.isRequired
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
    intl: intlShape
  };

  constructor(props) {
    super(props);
  }

  componentWillUnmount() {
    this.context.executeAction(clearMessages);
  }

  buildAlert(message) {
    return <div className='alert alert-success' role='alert'>
      <FormattedMessage {...message} />
    </div>;
  }

  render() {
    const editClicked = () => {
      console.info('User clicked edit account');
      this.context.executeAction(editAccount);
    };

    const clientChanged = (event) => {
      console.info('Client changed', event.target.value);
      this.context.executeAction(changeSelectedClient, event.target.value);
    };

    const {accountUpdated, passwordResetSent, firstName, lastName, emailAddress, title, enabledClients, selectedClient} = this.props;

    const flashMessages = [];

    if (accountUpdated) {
      flashMessages.push(this.buildAlert(AccountMessages.accountUpdated));
    }

    if (passwordResetSent) {
      flashMessages.push(this.buildAlert(AccountMessages.forgotComplete));
    }

    const clientOptions = Immutable.Seq(enabledClients).sortBy(client => (client.name || '').toLowerCase()).map(client => {
      return <option key={client.key} value={ client.key }>{ client.name }</option>;
    });

    const changeClient = enabledClients.length ?
      <ProtectedComponent role={Roles.CLIENT_MANAGER}>
        <section className='card'>
          <div className='card-body'>
            <h2>
              Change your client
            </h2>
            <select value={ selectedClient.key } onChange={ clientChanged }>
              { clientOptions }
            </select>
          </div>
        </section>
      </ProtectedComponent> : null;

    return (
      <div>
        <section className='card'>
          <div className='card-body'>
            { flashMessages }
            <div className='form-group row'>
              <label className='col-sm-3 offset-sm-1 col-form-label'>Email Address</label>
              <div className='col-sm-7'>
                <p className='form-control-static'>{ emailAddress }</p>
              </div>
            </div>
            <div className='form-group row'>
              <label className='col-sm-3 offset-sm-1 col-form-label'>First Name</label>
              <div className='col-sm-7'>
                <p className='form-control-static'>{ firstName }</p>
              </div>
            </div>
            <div className='form-group row'>
              <label className='col-sm-3 offset-sm-1 col-form-label'>Last Name</label>
              <div className='col-sm-7'>
                <p className='form-control-static'>{ lastName }</p>
              </div>
            </div>
            <div className='form-group row'>
              <label className='col-sm-3 offset-sm-1 col-form-label'>Title</label>
              <div className='col-sm-7'>
                <p className='form-control-static'>{ title }</p>
              </div>
            </div>
            <div className='form-group row'>
              <div className='buttons'>
                <Link className='btn btn-primary' onClick={ editClicked } to='/account/edit'>
                  <FormattedMessage {...CommonMessages.edit} />
                </Link>
              </div>
            </div>
          </div>
        </section>
        { changeClient }
      </div>
    );
  }
}

export default ViewAccount;



// WEBPACK FOOTER //
// ./src/apps/Account/components/ViewAccount.js